import {
  amplitudeApiKey,
  isProduction,
  rollbarApiKey,
  facebookPixelID,
  quoraPixelID,
} from '../config';
import { mutate } from './createApolloClient/createApolloClient.client';
import gql from 'graphql-tag';
import { getp } from '../helpers/getProp';
import * as Rollbar from 'rollbar';
import ReactPixel from 'react-facebook-pixel';
import ReactQuoraPixel from 'react-quora-pixel';

const options = {
  autoConfig: true, // set pixel's autoConfig
  debug: false, // enable logs
};

let rollbar;
const initRollbar = (accessToken, userId) => {
  rollbar = Rollbar.init({
    accessToken,
    transform: data => {
      Object.assign(data, {
        environment: 'web',
        person: {
          id: userId,
        },
        client: {
          ...data.client,
          javascript: {
            ...data.client.javascript,
          },
        },
      });
    },
    captureUncaught: true,
    captureUnhandledRejections: true,
  });
};

let instance = null;
if (process.env.BROWSER) {
  if (isProduction) {
    instance = require('amplitude-js').getInstance();
    instance.init(amplitudeApiKey, null, {
      includeUtm: true,
    });
    ReactPixel.init(facebookPixelID, {}, options);
    ReactPixel.pageView();
    ReactQuoraPixel.init(quoraPixelID);
    ReactQuoraPixel.track('ViewContent');
  } else {
    instance = {
      setUserId(userId) {
        console.log('ANALYTICS - userId', userId);
      },
      logEvent(eventType, data) {
        console.log('ANALYTICS - logEvent', eventType, data);
      },
      identify(data) {
        console.log('ANALYTICS - identify', data);
      },
      setUserProperties(data) {
        console.log('ANALYTICS - setUserProperties', data);
      },
    };
  }
}

export const identify = function(data) {
  if (process.env.BROWSER && instance) {
    instance.setUserProperties(data);
  }
};

export const setUserId = function(userId) {
  if (process.env.BROWSER) {
    instance.setUserId(userId);
    if (
      userId === 'c98a28b0-19c4-11e9-b6f4-1d1e5ebf963c' ||
      userId === '0b26f190-2d61-11e9-a434-a7b24ef1808d' ||
      userId === 'f9ae1860-195d-11e9-bf41-6bf8fabb2c89'
    ) {
      identify({ role: 'admin' });
    }

    if (isProduction) {
      initRollbar(rollbarApiKey, userId);
    }
  }
};

export const track = function(eventType, data) {
  // #2 - Consistent data keys & eventTypes
  if (process.env.BROWSER) {
    instance.logEvent(eventType, data);
  }
  // #3 Log ViewDetails twice, once in analytics, once in DB. data.path === '/details'
};

export const trackPageView = function(path, listId) {
  // CHECK all keys on data if they exist in valid keys;
  const data = {
    path,
    listId,
  };
  track('PAGEVIEW', data);
};

export const trackClick = function(page, text) {
  track('CLICK', { page, text });
};

export const trackSearch = function(query) {
  track('SEARCH', query);
};
export const trackBooking = function(listId, step) {
  track('BOOKING', { listId, step });
};
export const trackAppDownloadClick = function(storetype) {
  track('APP_DOWNLOAD_CLICK', { storetype });
};

export const addListingView = function(stepName) {
  const data = {
    stepName,
  };
  track('ADD_LISTING', data);
};
export const trackContactHost = function(price, category) {
  const data = { price, category };
  track('CONTACT_HOST_START', data);
};
export const trackContactHostEnd = function() {
  track('CONTACT_HOST_END');
};
export const trackApproval = function(total, numDays, category) {
  const data = {
    total,
    units: numDays,
    unitType: 'days',
    category,
  };

  track('APPROVE_RESERVATION', data);
};
export const trackDeny = function(total, numDays, category) {
  const data = {
    total,
    units: numDays,
    unitType: 'days',
    category,
  };
  track('DENY', data);
};

export const trackToggleMapSearch = function() {
  track('MAP_SEARCH_TOGGLE');
};

export const trackBookFromInbox = function(category, listId) {
  const data = {
    listId,
  };
  track('BOOK_FROM_INBOX', data);
};

export const trackRegister = function(data) {
  track('REGISTER', data);
  ReactPixel.track('CompleteRegistration');
};

export const trackPublish = function(publishPhase) {
  track('PUBLISH_CHANGE', {
    publishPhase: publishPhase === 'publish' ? 'publish' : 'unpublish',
  });
};
// TO WIRE UP

export const trackListView = function(listId, category, category2) {
  //CHECK all keys on data if they exist in valid keys;
  const data = {
    path: '/details',
    listId,
    category,
    category2,
  };
  track('PAGEVIEW', data);

  if (process.env.BROWSER) {
    mutate(
      gql`
        mutation UpdateListViews($listId: Int) {
          UpdateListViews(listId: $listId) {
            status
          }
        }
      `,
      { listId },
    );
  }
};

export const trackCancel = function() {
  track('CANCELLATION');
};

// TO TRACK

// HOME
// SEARCH
// DETAILS
//  - Category
//  - listId

// VIEW
// trackSearch
//  - Keywords
//  - Categories
//  - minRating
//  - Availability
//  - PriceMin
//  - Price Max
//  - Day of Week
//  - Total results ?

// REGISTER
//  - timestamp

// trackPageView - Inbox

// trackPageView - Add Listing
//  - Timestamp

// ADD LISTING ACTIONS
// Next - current step
//  - Timestamp
// Publish
//  - Timestamp

// SEARCH ACTIONS
//  - Next/Preview Page
//  - Toggle Search as I move the map

// DETAILS ACTIONS
// Book (start Request)
//   - listId
//   - Timestamp
// Contact Host
//  - Timestamp
// Booking Success
//  - listId
//  - Timestamp

// INBOX ACTIONS
// Book from Inbox
//  - Timestamp
// Approve
//   - Total
//   - numDays
//   - item Category
//   - Timestamp
// Deny
// Cancellation

// https://docs.expo.io/versions/latest/sdk/amplitude/



// WEBPACK FOOTER //
// ./src/core/analytics.js